import React from 'react';
import ServiceCard from '../components/common/ServiceCard';
import { SERVICES_DEFAULT } from '../utils/constants';

const Services = () => {
    return (
        <div className="page">
            <section className="section">
                <h2>Our Services</h2>
                
                <div className="grid grid-2" style={{ marginTop: '40px' }}>
                    {SERVICES_DEFAULT.map(service => (
                        <ServiceCard
                            key={service.id}
                            icon={service.icon}
                            title={service.name}
                            description={service.description}
                        />
                    ))}
                </div>
            </section>
        </div>
        

        
    );
};

export default Services;